/**
 * PriorityHighIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const PriorityHighIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M12 13.175 4.575 19.05q-.5.35-1.037.087Q3 18.876 3 18.25q0-.25.112-.475a.85.85 0 0 1 .313-.35l8.575-6.7 8.575 6.7q.2.125.313.35.111.225.112.475 0 .6-.538.875-.537.275-1.037-.075zm0-5.95L4.575 13.1q-.5.35-1.037.088Q3 12.925 3 12.3q0-.25.112-.475a.85.85 0 0 1 .313-.35L12 4.775l8.575 6.7q.2.125.313.35.111.225.112.475 0 .6-.538.875-.537.274-1.037-.075z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const PriorityHighIcon = makeIcon('PriorityHighIcon', PriorityHighIconSvg)
